<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '110px'">
      <div class="line-box" >
      <el-form-item label="唯一标识" prop="buildSn" class="styW">
          <el-input v-model="dataForm.buildSn" placeholder="唯一标识"></el-input>
      </el-form-item>
      <el-form-item label="运营机构名称" prop="name" class="styW">
          <el-input v-model="dataForm.name" placeholder="运营机构名称"></el-input>
      </el-form-item>
      
      <el-form-item label="状态" prop="status" class="styW">
          <el-select v-model="dataForm.status" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in statusList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
          </el-select>
      </el-form-item>
    </div>
      <el-form-item  label="备注" prop="remark">
          <el-input type="textarea" v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      statusList:[
        {
            'label':'停用',
            'value':0,
        },
        {
            'label':'正常',
            'value':1,
        }
      ],
      dataForm: {
        id: '',
        buildSn: '',
        name: '',
        status: '',
        remark: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        buildSn: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/operations/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$unblank(this.dataForm)
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/operations/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>

<style scoped lang="scss">
.styW{
  width: 280px;
}
.line-box{
  display: flex;
  flex-wrap: wrap;
}
</style>